var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMultiChain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 110,
    viewBox: "0 0 136 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M109.827 71.5693L90.6786 60.8405V39.6549C90.6786 38.8397 90.2714 38.0253 89.4562 37.618L69.0858 26.3467C68.4068 25.9395 67.5917 25.9395 66.9127 26.3467L46.5423 37.618C45.8633 38.0252 45.3199 38.8404 45.3199 39.6549V60.9757L26.1715 71.7045C25.4926 72.1117 24.9492 72.9268 24.9492 73.7413V96.42C24.9492 97.2352 25.3564 98.0496 26.1715 98.4569L46.542 109.728C46.9492 109.864 47.2209 110 47.6281 110C48.0353 110 48.4433 109.864 48.7142 109.728L67.9996 98.7292L87.2833 109.458C87.6905 109.594 87.9622 109.73 88.3695 109.73C88.7767 109.73 89.1846 109.594 89.4556 109.458L109.826 98.1867C110.505 97.7795 111.048 96.9643 111.048 96.1498L111.049 73.6063C111.049 72.7911 110.506 71.9768 109.827 71.5689L109.827 71.5693ZM88.3709 82.2981L72.6179 73.6069L88.3709 64.7794L104.124 73.4705L88.3709 82.2981ZM65.6922 52.2851V69.8038L49.803 60.9763V43.4576L65.6922 52.2851ZM70.3091 52.2851L86.0627 43.4576V60.9763L70.1735 69.8038V52.2851H70.3091ZM47.6304 64.779L63.3834 73.4701L47.6304 82.2977L31.8774 73.6065L47.6304 64.779ZM49.9388 86.235L65.6924 77.4082V94.9269L49.8032 103.754V86.235H49.9388ZM68.0011 30.8275L83.7541 39.5187L68.0011 48.3462L52.248 39.6551L68.0011 30.8275ZM29.5684 77.4076L45.4576 86.2352V103.754L29.5684 94.9263V77.4076ZM70.3093 77.4076L86.1985 86.2352V103.754L70.3093 94.9263V77.4076ZM90.6798 103.617V86.234L106.433 77.4073V94.9259L90.6798 103.617Z",
    fill: "#3761F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3218 72.3843H49.8033V76.8657H45.3218V72.3843Z",
    fill: "#00CD98"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0985107 85.9634H4.57998V90.4448H0.0985107V85.9634Z",
    fill: "#00CD98"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0627 72.3843H90.5442V76.8657H86.0627V72.3843Z",
    fill: "#00CD98"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6923 38.4331H70.1737V42.9146H65.6923V38.4331Z",
    fill: "#00CD98"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.19775 85.9634H20.4691V90.4448H9.19775V85.9634Z",
    fill: "#00CD98"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M131.42 85.9634H135.902V90.4448H131.42V85.9634Z",
    fill: "#00CD98"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M115.531 85.9634H126.802V90.4448H115.531V85.9634Z",
    fill: "#00CD98"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6923 9.09961H70.1737V22.6804H65.6923V9.09961Z",
    fill: "#00CD98"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6923 0H70.1737V4.48146H65.6923V0Z",
    fill: "#00CD98"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiChain);
export default __webpack_public_path__ + "static/media/multi-chain.7e71d9ad90b1e94f0f596694aaf0d215.svg";
export { ForwardRef as ReactComponent };